/**
 * Product mockup used in the hero and the pricing card.
 * TODO: upload the cover mockup (book on the field at sunset) to Magic Patterns
 * and paste its URL here. While empty, a code-drawn cover in the same look is shown.
 */
export const PRODUCT_MOCKUP = ''

/** Hero image: the six volumes fanned out on the field at sunset. */
export const HERO_IMAGE =
  'https://cdn.magicpatterns.com/uploads/mmyVTiVUsVguwm2nKrgRdt/DPS-27_hero_3x2.png'

export const HERO_IMAGE_ALT =
  'The six No-Lines Lacrosse volumes — First Practices, Move the Ball, Defense Without Slashing, The Game Bank, Game Ready and Specialists — fanned out on a lacrosse field at sunset'

/** Where every buy button sends the coach. TODO: confirm the real checkout URL. */
export const CHECKOUT_URL = 'https://no-lines-lacrosse.impultienda.ar/checkout'

export const PRODUCT_MOCKUP_ALT =
  'No-Lines Lacrosse: Every Youth Practice, Planned — the book on a lacrosse field at sunset, next to a helmet and a stick'
